export function ParseDate(text) {
    if (text) return text.slice(8,10)+"/"+text.slice(5,7)+"/"+text.slice(0,4);
}